const STRUCT = {
  ID: 'id',
  CLIENT_INFO: 'clientInfo',
  MEETING: 'meeting',
  GRADES: 'grades',
};

export default STRUCT;
